import React from 'react'

import {
  AspectRatio,
  Box,
  Button,
  Card,
  Flex,
  HStack,
  Text,
} from '@chakra-ui/react'
import { LocalVideoTrack } from 'agora-rtc-react'
import { CameraOn } from 'src/components/icon'
import { Select } from 'src/components/Select/Select'

import { useLocalPlayer } from '../../context/localPlayerContext'
import { useDeviceSelection } from '../../hooks/useDeviceSelection'
import { useMediaDevices } from '../../hooks/useMediaDevices'

export const CameraPreviewPanel: React.FC = () => {
  const {
    localCameraTrack,
    localCameraError,
    currentCameraDeviceId,
    switchCamera,
    toggleLocalCamera,
  } = useLocalPlayer()
  const { cameraDevices } = useMediaDevices()
  const [selectedCameraId, setSelectedCameraId] = useDeviceSelection(
    currentCameraDeviceId,
    cameraDevices,
    switchCamera,
  )

  const isActive = localCameraTrack !== null
  const hasError = localCameraError !== null

  return (
    <Card p="4">
      <Flex direction="column" gap="3">
        <HStack spacing="2">
          <Box color="gray.700">
            <CameraOn />
          </Box>
          <Text fontWeight="bold" fontSize="md">
            カメラ
          </Text>
        </HStack>
        {isActive ? (
          <AspectRatio ratio={16 / 9} maxW="md">
            <Box bg="gray.800" borderRadius="md" overflow="hidden">
              <LocalVideoTrack
                track={localCameraTrack ?? undefined}
                play={!!localCameraTrack}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />
            </Box>
          </AspectRatio>
        ) : (
          <div>
            <Button
              onClick={toggleLocalCamera}
              isDisabled={hasError}
              colorScheme="blue"
              variant="outline"
            >
              カメラを確認する
            </Button>
          </div>
        )}

        {cameraDevices.length > 0 && (
          <Flex direction="column" gap="1" w="max-content">
            <Text fontSize="sm" color="gray.600">
              使用するカメラ
            </Text>
            <Select
              value={selectedCameraId}
              items={cameraDevices.map(device => ({
                value: device.deviceId,
                label: device.label,
              }))}
              onChange={deviceId => setSelectedCameraId(deviceId)}
            />
          </Flex>
        )}
      </Flex>
    </Card>
  )
}
